
import Analytics from '../utilities/analytics.js';


/**
 * Fires the analytics for video embeds on the page. This will "bypass" any
 * iframes within the React code, as it runs before React has fired.
 * This code only supports vimeo and youtube iframe embeds.
 */
(function(window, jQuery) {
  if (window.articleAnalytics) {
    jQuery(function() {
      var iframes = jQuery('iframe');

      if (iframes.length) {
        for (var i = 0; i < iframes.length; i++) {
          var tmp = iframes[i];

          if (Analytics.VideoEmbeds.isVimeo(tmp)) {
            Analytics.VideoEmbeds.VimeoFactory.initialise(
              tmp,
              window.articleAnalytics
            );
          }
          if (Analytics.VideoEmbeds.isYouTube(tmp)) {
            Analytics.VideoEmbeds.YouTubeFactory.initialise(
              tmp,
              window.articleAnalytics
            );
          }
        }
      }
    });
  }
})(window, jQuery);

